jQuery(document).ready(function() {

// Custom JS functions
setTimeout(function() {
   jQuery('#changeColor').addClass('changed');
}, 4000);

});



// WEBPACK FOOTER //
// ./scripts/mta.js